<template>
<div>
    <div class="animated fadeInUp card-dados-voo" v-if="Object.keys(posicaoAtual).length > 0">
        <div class="row">
            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.velocidade}} Kt  </div>
                <small>VELOCIDADE</small>
            </div>

            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.direcao}}º  </div>
                <small>DIREÇÃO</small>
            </div>
        </div>

        <div class="row">

            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.altitude}} m  </div>
                <small>ALTITUDE</small>
            </div>

            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.altitudeGoogle}} m  </div>
                <small>SOLO</small>
            </div>
        </div>

        <div class="row">
            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.data}}  </div>
                <small>DATA</small>
            </div>
            <div class="col-6 text-center">
                <div class="informacao">{{posicaoAtual.dataUTC}}  </div>
                <small>UTC</small>
            </div>
        </div>

        <div class="row">
            <div class="col-6 text-center">
                <div style="margin-bottom: -6px;">{{posicaoAtual.lat}}  </div>
                <small style="color: rgb(0, 82, 204)">LATITUDE</small>
            </div>
            <div class="col-6 text-center">
                <div style="margin-bottom: -6px;">{{posicaoAtual.lng}} </div>
                <small style="color: rgb(0, 82, 204)">LONGITUDE</small>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        posicaoAtual: {
            type: Object,
            required: true,
            default: null
        }
    }
}
</script>


<style lang="scss" scoped>
.card-dados-voo{
	position: absolute;
	bottom: 0px;
	width: 100%; 
	margin-left: -20px; 
	margin-bottom:6px;

	.row {
		margin-top:8px;
	}

	small {
		color: rgb(0, 82, 204)
	}
	
	.informacao {
		margin-bottom: -6px;
	}
}
</style>





// WEBPACK FOOTER //
// src/views/monitoramento/card-dados-voo.vue